/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Ui_Studio_Delete_DescInputs */

const en_ui_studio_delete_desc = /** @type {(inputs: Ui_Studio_Delete_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete "${i?.name}"? The imported route is removed — your sessions are untouched.`)
};

const de_ui_studio_delete_desc = /** @type {(inputs: Ui_Studio_Delete_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.name}" löschen? Die importierte Route wird entfernt — deine Sessions bleiben unberührt.`)
};

/**
* | output |
* | --- |
* | "Delete \"{name}\"? The imported route is removed — your sessions are untouched." |
*
* @param {Ui_Studio_Delete_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_delete_desc = /** @type {((inputs: Ui_Studio_Delete_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Delete_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_delete_desc(inputs)
	return de_ui_studio_delete_desc(inputs)
});